import { keyMap } from "./fieldRegistry";

/**
 * Pressure Vessel Edge Mentor field resolver.
 *
 * Converts existing PV control names to the code_label
 * used by Edge Mentor content.
 *
 * Examples:
 *   txtDPressure -> designInternalPressure
 *   ComboBox20   -> radiography
 *   TextBox49    -> windSpeed
 *
 * If the field already uses the modern code label,
 * it passes through unchanged.
 */
export const resolvePVEdgeMentorCodeLabel = (rawFieldName) => {
  const fieldName = String(rawFieldName || "").trim();

  if (!fieldName) {
    return "";
  }

  return keyMap[fieldName] || fieldName;
};

export default resolvePVEdgeMentorCodeLabel;
